export const VIEW_MODE = {
  DESKTOP: 'DESKTOP',
  MOBILE: 'MOBILE',
};

export const EDITOR_TYPE = {
  EDITOR: 'EDITOR',
  EDITORX: 'EDITORX',
  ADI: 'ADI',
  STUDIO: 'STUDIO',
};

export type CommentForm = {
  message: string;
  userName: string;
  userEmail: string;
};

export const ANONYMOUS = 'Anonymous';

export const MAX_MESSEGE_LENGTH = 1999;

export const FEEDBACK_FORM_ACTIONS = {
  CLIENT_COMMENT_ACTIONS: 'commentClientActions',
  REPLY_ACTIONS: 'replyActions',
  REPLY_TIME: 'replyTime',
};

export const COMMENT_STATUS = {
  UNREAD: 'New',
  OPEN: 'Open',
  RESOLVED: 'Resolved',
  DELETED: -1,
};

export const CLIENT_ADD_COMMENT_HELP_LINK = (locale: string) => {
  const translatedLocales = ['fr', 'es', 'it', 'ja', 'de', 'pt', 'ru'];
  const supportedLocale = translatedLocales.includes(locale) ? locale : 'en';
  return `https://support.wix.com/${supportedLocale}/article/wix-editor-providing-site-feedback`;
};

export const PREVIEW_ID = 'previewFrame';
export const DOCUMENT_HEADER = 'SITE_HEADER';
export const DOCUMENT_CONTAINER = 'SITE_CONTAINER';

export const COMMENT_STATUS_CLIENT = {
  NEW: 'Pending',
  POSTED: 'New',
  RESOLVED: 'Resolved',
  READ: 2,
  EDIT: 4,
};

export const GET_INITIALIZE_DATA = `/feedback/getInitializeData`;
export const ADD_COMMENT = `/feedback/addComment`;
export const CREATE_CONTACT = `/feedback/createContact`;
export const DELETE_COMMENT = `/feedback/deleteComment`;
export const UPDATE_COMMENT = '/feedback/updateComment';
export const REPLY_TO_COMMENT = '/feedback/replyToComment';
export const CLIENT_REPLY_TO_COMMENT = '/feedback/clientReplyToComment';

export const BREAKPOINT_MAX_VALUE = -1;
export const BREAKPOINT_MAX_ID = 'max';
export const GET_ORIGIN_FROM_WINDOW_SPEC = 'specs.experts.getOriginFromWindow';
export const ADD_AUTHORIZATION_HEADERS = 'specs.experts.addAuthorizationHeader';
export const SHOW_MEANINGFUL_ERROR_MSG = 'specs.experts.showMeaningfulErrorMsg'
